import { NumberDate, Timestamp } from '@lemon/core/model/common'
import { Lasku } from './lasku'

/** Polussa /customers/{asiakasAvain}/customer-laskut-toistuvat/{toistuvaLaskuAvain} */
export interface ToistuvaLasku {
  toisto: LaskuLahetyksenToistoasetukset
  lasku: Lasku
  seuraavaLahetysPvm: NumberDate
  /** Kuinka monta kertaa lasku on lähetetty */
  lahetyksia: number
  paivitetty: Timestamp
  paivittaja: string
  poistettu: boolean
}

/** Laskun lähetyksen toistoasetukset */
export interface LaskuLahetyksenToistoasetukset {
  ensimmainenLahetyspvm: NumberDate
  toistoTyyppi: LaskuToistoTyyppi
  paattyminen: ToistonPaattyminen
  lahetyspaiva?: KuukausittainenLahetysPaiva | VuosittainenLahetysPaiva
}

export const LAHETYSMAARA_MIN = 1
export const LAHETYSMAARA_MAX = 999

/** Kuinka usein lasku toistetaan */
export enum LaskuToistoTyyppi {
  KERRAN = 'kerran',
  KUUKAUSI = 'kk',
  KUUKAUSI_3 = 'kk3',
  KUUKAUSI_6 = 'kk6',
  VUOSI = 'vuosi',
}

export enum Viikonpaiva {
  MAANANTAI = 1,
  TIISTAI = 2,
  KESKIVIIKKO = 3,
  TORSTAI = 4,
  PERJANTAI = 5,
  LAUANTAI = 6,
  SUNNUNTAI = 7,
}

export enum KuukaudenJarjestysnumero {
  ENSIMMAINEN = 1,
  TOINEN = 2,
  KOLMAS = 3,
  NELJAS = 4,
  VIIMEINEN = -1,
}

/** Kuukausivalintojen tyyppi */
export enum KuukaudenLahetysTyyppi {
  /** Päivämäärä (1-31) */
  PAIVAMAARA = 'pvm',
  /** Päivä (esim. "kuun viimeinen perjantai") */
  PAIVA = 'paiva',
}

/** Päättymisen tyyppi */
export enum ToistonPaattymisTyyppi {
  /** Ei päättymispäivää (jatkuu toistaiseksi) */
  EI_PAATTYMISTA = 'ei',
  /** Päättyy tiettynä päivämääränä */
  PAATTYMISPVM = 'pvm',
  /** Päättyy tietyn määrän lähetyksiä jälkeen */
  LAHETYSMAARA = 'maara',
  /** Päättyy yhden lähetyksen jälkeen (käytetään kun toistotyyppi = KERRAN) */
  KERRAN = 'kerran',
}

/** Kuukausikohtainen lähetyspäivä - päivämäärä */
export interface KuukausittainenLahetysPaivaPaivamaara {
  tyyppi: KuukaudenLahetysTyyppi.PAIVAMAARA
  paiva: number
}

/** Kuukausikohtainen lähetyspäivä - viikonpäivä */
export interface KuukausittainenLahetysPaivaPaiva {
  tyyppi: KuukaudenLahetysTyyppi.PAIVA
  jarjestysnumero: KuukaudenJarjestysnumero
  viikonpaiva: Viikonpaiva
}

export type KuukausittainenLahetysPaiva = KuukausittainenLahetysPaivaPaivamaara | KuukausittainenLahetysPaivaPaiva

/** Vuosikohtainen lähetyspäivä (kk/pv) */
export interface VuosittainenLahetysPaiva {
  kuukausi: number
  paiva: number
}

/** Päättyminen - ei päättymispäivää (jatkuu toistaiseksi) */
export interface ToistonPaattyminenEi {
  tyyppi: ToistonPaattymisTyyppi.EI_PAATTYMISTA
}

/** Päättyminen - kerran lähetyksen jälkeen */
export interface ToistonPaattyminenKerran {
  tyyppi: ToistonPaattymisTyyppi.KERRAN
}

/** Päättyminen - päivämäärä */
export interface ToistonPaattyminenPvm {
  tyyppi: ToistonPaattymisTyyppi.PAATTYMISPVM
  paattymispvm: NumberDate
}

/** Päättyminen - lähetysmäärä */
export interface ToistonPaattyminenMaara {
  tyyppi: ToistonPaattymisTyyppi.LAHETYSMAARA
  lahetysmaara: number
}

export type ToistonPaattyminen = ToistonPaattyminenEi | ToistonPaattyminenKerran | ToistonPaattyminenPvm | ToistonPaattyminenMaara

export interface LaskuLahetyksenToistoasetusVirhe {
  kentta: string
  viesti: string
}

export interface ToistuvatLaskutWorkQueueData {
  asiakasAvain: string
  asiakasId: string
  toistuvaLuonnosAvain: string
  handler: string
  lastTriedMillis: number
}

export interface TestaaToistuvaLaskuPyynto {
  toistuvaLaskuAvain: string
}

export interface TestaaToistuvaLaskuVastaus {
  success: boolean
  message: string
  tyojonoAvain: string
}
